export default {
  acknowledgment: {
    ageRestricted: 'Age Restricted',
    dontAskAgain: 'Don\'t ask me again',
    legalDrinkingAge: 'By continuing, you acknowledge that you are of legal drinking age',
    showIdPrompt: 'Please be prepared to show ID upon request'
  },
  actions: {
    add: 'Add',
    addNew: 'Add New',
    addThing: 'Add {thing}',
    applied: 'Applied',
    apply: 'Apply',
    call: 'Call',
    cancel: 'Cancel',
    change: 'Change',
    changeTo: 'Change To {subject}',
    close: 'Close',
    confirm: 'Confirm',
    delete: 'Delete',
    deleteAll: 'Delete All',
    dismiss: 'Dismiss',
    edit: 'Edit',
    favorited: 'Favorited',
    learnMoreAbout: 'Learn More About {subject}',
    link: 'Link',
    loadMore: 'Load More',
    prorate: 'Prorate',
    remove: 'Remove',
    replace: 'Replace',
    retry: 'Retry',
    review: 'Review',
    save: 'Save',
    seeAll: 'See All',
    selected: 'Selected',
    summarizeBy: 'Summarize By',
    update: 'Update',
    watched: 'Watched',
    reserve: 'Reserve'
  },
  assertion: {
    happyToReceiveMarketingFrom: 'I am happy to receive showtimes, marketing, and other useful information from {siteName}',
    no: 'No',
    notNow: 'Not Now',
    or: 'Or',
    tosAgreement: 'I have read and agree to the {termsOfService}',
    tosAndPrivacyPolicyAgreement: 'I have read and agree to the {termsOfService} and {privacyPolicy}',
    yes: 'Yes'
  },
  auth: {
    actions: {
      goToForgotPassword: 'Forgot Password',
      login: 'Log In',
      loginToDo: 'Log In to {action}',
      logout: 'Log Out',
      register: 'Sign Up',
      registerOrLogin: 'Sign Up / Log In',
      sendEmailToClaimAccount: 'Send Email To Claim Account',
      sendPasswordResetEmail: 'Send Reset Email',
      signup: 'Sign Up'

    },
    logInConfirmation: 'Welcome {name}, You are now logged in',
    activateAccountHeading: 'Activate Account',
    alreadyHaveAnAccountQuestion: 'Already have an account?',
    areYouAnExistingCustomerQuestion: 'Are you an existing customer?',
    claimingAccountExplanation: 'In order to claim your account we need to associated an email address with your account',
    claimingAccountInstructions: ctx => {
      const siteEmail = ctx.named('siteEmail') || ''
      const sitePhone = ctx.named('sitePhone') || ''
      let message = 'You can do this by coming into the theater, emailing us'
      message += siteEmail ? ` at ${siteEmail}` : ''
      message += sitePhone ? ` or calling ${sitePhone}` : ' or calling us by phone'
      return message
    },
    claimingAnAccountHeading: 'Claiming Account',
    claimYourAccountHeading: 'Claim Your Account',
    dontHaveAnAccount: 'Don\'t have an account?',
    existingAccountPromptToClaim: 'You have an account / membership with the theater. Click here to claim your account',
    existingAccountPromptToClaimWithoutEmail: 'You have an account / membership with the theater but no email address on file',
    noAccountPromptToRegister: 'You do not have an account / membership with the theater. Click here to sign up!',
    resetPasswordHeading: 'Reset Your Password',
    resetPasswordSent: 'Reset password email sent'
  },
  card: {
    card: 'Card | Cards',
    number: 'Card Number'
  },
  cart: {
    cartEmpty: 'Empty Cart',
    clearCart: 'Clear Cart',
    collectedAt: 'Collected At',
    hideCart: 'Hide Cart',
    removeTickets: 'Remove Tickets',
    viewCart: 'View Cart',
    yourCartIsEmpty: 'Your Cart is Empty'
  },
  checkout: {
    actions: {
      addGiftCardVoucherPromoCode: 'Add Gift Card, Voucher, Promo Code',
      checkout: 'Checkout',
      continueAsGuest: 'Continue as Guest',
      continueShopping: 'Continue Shopping',
      nextStep: 'Next: {step}',
      startOver: 'Start Over',
      continue: 'Continue',
      manageMembership: 'Manage Membership'
    },
    addCardToTab: 'Add Card to Tab',
    authRequiredForTicketsPromptConsumer: 'Sign In to Purchase Tickets',
    authRequiredForTicketsPromptKiosk: 'Account Required to Purchase Tickets',
    confirmLeaveCheckoutPrompt: 'Are you sure you would like to leave checkout?',
    continueOrder: 'Would you like to continue your order?',
    delivery: {
      deliveryInformation: 'Delivery Information',
      deliveryTo: 'Delivery To',
      groupOrder: 'Group Order',
      groupOrderDescription: 'Select the seats in your group that can order items on your tab',
      justMe: 'Just Me',
      pickupAt: 'Pickup At',
      select: 'Select Delivery Location',
      selectOptionPrompt: 'Select An Option',
      selectSeats: 'Select Seats',
      yourSeat: 'Your Seat'
    },
    discountsDisclaimer: 'Discounts do not apply to fees or taxes',
    errors: {
      seatSelection: {
        title: 'Seat selection issue',
        message: 'There are issues with one or more of your selected seats.',
        okLabel: 'Review and fix',
        cancelLabel: 'Abandon tickets'
      }
    },
    guestCheckoutHeading: 'Guest Checkout',
    infoTitles: {
      concessions: 'Concessions',
      giftCards: 'Gift Cards',
      seatsSelected: 'Seats Selected',
      tickets: 'Tickets',
      vouchers: 'Vouchers'
    },
    keepTabOpen: 'Keep Tab Open',
    keepTabOpenPrompt: 'Want to keep your tab open?',
    leaveCheckoutHeading: 'Leave Checkout',
    memberSignUpOrDayPassPrompt: 'Become a member or buy a Day Pass to purchase tickets',
    memberSignUpPrompt: 'Become a member to purchase tickets',
    mustSelectSeatsPrompt: 'Please select seats for this showing or remove your tickets to continue',
    nextLabels: {
      cart: 'Cart',
      completeOrder: 'Complete Order',
      food: 'Food',
      moreFilms: 'More Films',
      pickSeats: 'Pick Seat | Pick Seats',
      redemptions: 'Redemptions'
    },
    orderComplete: 'Order Complete',
    orderPlaced: 'Order Placed',
    orderPlacedAndSent: 'Your order has been placed and confirmation email sent!',
    orderPlacedAsOpenTab: 'Your order has been placed as an open tab',
    orderPlacedLogInPrompt: 'Log In now to manage your order',
    orderPlacedSignUpPrompt: 'Sign Up now to manage your order',
    orderPlacedWithGuestDetailsPrompt: 'Your order has been placed! Finish up your membership by entering your guest details now, or the next time you use your membership',
    orderPlacing: 'Placing Order...',
    orderProcessing: 'Please wait while we process your order',
    orPayNow: 'Or Pay Now',
    paymentOptions: 'Payment Options',
    QRCodeOrderingPrompt: 'You can continue ordering via the QR code or directly from a server. We will collect payment information now.',
    receiveBenefitsHeading: 'Receive benefits',
    redeemCurrencyPrompt: 'Redeem your {rewardsCurrencyName} during checkout',
    registerPromptTitle: 'Don\'t have an account?',
    registerPromptDescription: 'Sign up to earn {rewardsCurrencyName} for every purchase to be redeemed for rewards',
    scanCardOrSelectOptionPrompt: 'Scan Membership Card Now or Select Option Below',
    signUpOrDayPassPrompt: 'Haven\'t signed up yet? Include a Day Pass with your order',
    startNewTab: 'Start a Tab',
    stepNumberOfTotal: 'Step {step} of {total}',
    steps: {
      cart: 'Cart',
      foodAndDrink: 'Food & Drink',
      logIn: 'Log In',
      membership: 'Membership',
      moreFilms: 'More Films',
      payment: 'Payment',
      redemptions: 'Redemptions',
      seats: 'Seats',
      tickets: 'Tickets'
    },
    thankYouForOrder: 'Thank You For Your Order',
    viewPaymentOptions: 'Click to view payment options'
  },
  collection: {
    all: 'All',
    current: 'Current',
    none: 'None',
    other: 'Other | Others',
    past: 'Past',
    total: 'Total',
    upcoming: 'Upcoming'
  },
  common: {
    at: 'at',
    favorite: 'Favorite | Favorites',
    food: 'Food',
    for: 'for',
    misc: 'Miscellaneous',
    nameGreeting: 'Hi, {name}',
    optional: 'Optional',
    or: 'or',
    owner: 'Owner',
    privacyPolicy: 'Privacy Policy',
    required: 'Required',
    socialDistance: 'Social Distance',
    termsOfService: 'Terms of Service'
  },
  creditCard: {
    actions: {
      add: 'Add Credit Card',
      addDefault: 'Add Default Credit Card',
      manage: 'Manage Credit Card'
    },
    addHeading: 'Add Credit Card',
    creditCard: 'Credit Card | Credit Cards',
    noCardOnFile: 'No card on file',
    noDefault: 'No default credit card',
    removeHeading: 'Remove Default Credit Card',
    removePrompt: 'Are you sure you want to remove your default credit card?',
    removeWithMembershipAutoRenewPrompt: 'Your membership will not be able to auto-renew without a default payment method. Are you sure you want to remove your default payment method?',
    savedCreditCard: 'Saved Credit Card',
    saving: 'Saving credit card...',
    updateHeading: 'Update Credit Card'
  },
  currency: {
    AUD: {
      hundredthsSymbol: '¢',
      name: 'Dollar',
      symbol: '$'
    },
    CAD: {
      hundredthsSymbol: '¢',
      name: 'Dollar',
      symbol: '$'
    },
    EUR: {
      hundredthsSymbol: '¢',
      name: 'Euro',
      symbol: '€'
    },
    GBP: {
      hundredthsSymbol: 'p',
      name: 'Pound',
      symbol: '£'
    },
    NZD: {
      hundredthsSymbol: '¢',
      name: 'Dollar',
      symbol: '$'
    },
    USD: {
      hundredthsSymbol: '¢',
      name: 'Dollar',
      symbol: '$'
    }
  },
  errors: {
    invalidToken: 'Invalid token'
  },
  form: {
    actions: {
      submit: 'Submit'
    },
    enterAddressForAutocompletePrompt: 'Enter your address or zip code',
    errors: {
      cannotBeLessThanAmount: 'Cannot be less than {amount}',
      cannotBeMoreThanAmount: 'Cannot be more than {amount}',
      emailNotFound: 'Email not found',
      emailNotValid: 'Not a valid email address',
      passwordsDoNotMatch: 'Passwords do not match',
      passwordTooShort: 'Password too short',
      phoneNotValid: 'Not a valid phone number',
      required: 'Field is required',
      termsOfServiceRequired: 'Please agree to the Terms of Service to continue',
      validEmailRequired: 'A valid email address is required'
    },
    labels: {
      address: 'Street Address',
      city: 'City',
      dateOfBirth: 'Date of Birth',
      emailAddress: 'Email',
      firstName: 'First Name',
      fullAddress: 'Full Address',
      lastName: 'Last Name',
      password: 'Password',
      phoneNumber: 'Phone Number',
      repeatPassword: 'Repeat Password',
      state: 'State',
      zipCode: 'Zip Code'
    },
    masks: {
      phoneNumber: '###-###-####'
    },
    hint: {
      maxSelections: 'Max {count} selections',
      mobileDisplayLimit: 'Only the top {count} will display on mobile'
    }
  },
  giftCard: {
    actions: {
      add: 'Add Gift Card',
      apply: 'Apply Gift Card',
      enterCode: 'Enter Gift Card Code'
    },
    addedAsPaymentMethod: 'Gift Card Added As Payment Method',
    addedWithValue: 'Gift Card Added, With Value of {value}',
    addSuccessPrompt: 'Gift card {code} added! It has a balance of {amount}',
    addToAccount: 'Add Gift Card to Account',
    balance: 'Balance',
    balanceAmount: 'Gift Card Balance: {amount}',
    errors: {
      alreadyAdded: 'Gift Card {code} has already been added! The current balance is {amount}',
      empty: 'Gift Card Empty',
      expired: 'Gift Card has expired',
      notFound: 'Gift Card not found',
      notValid: 'Gift Card is not valid'
    },
    giftCard: 'Gift Card | Gift Cards',
    giftCardBalance: 'Gift Card Balance',
    giftCardCount: '{count} Gift Card | {count} Gift Cards',
    giftCardNumber: 'Gift Card number',
    noActiveGiftCards: 'It looks like you don\'t have a gift card in your account yet. Tap "Add Gift Card" to get started',
    noUsedOrExpiredGiftCards: 'No used or expired gift cards found'
  },
  isoDateInput: {
    shortDate: {
      displayFormat: 'MM/DD/YYYY',
      placeholder: 'MM/DD/YYYY'
    }
  },
  item: {
    item: 'Item | Items',
    itemCount: '{count} Item | {count} Items'
  },
  kiosk: {
    actions: {
      acknowledge: 'I understand'
    },
    errors: {
      hardwareProblems: 'Problems found with hardware, some features may not work',
      issueWithPrinter: 'There is an issue with the printer. Please add your details and see the counter staff.',
      noInternet: 'No Internet Connection',
      underMaintenance: 'This terminal is undergoing maintenance, apologies for the inconvenience',
      problemSendingEmail: 'There was a problem sending the email. Please see the counter staff.'
    },
    inactivityPrompt: 'Are you still there?',
    kiosk: 'Kiosk | Kiosks',
    scanCardPrompt: 'Scan Membership Card Now',
    scanOrderPrompt: 'Scan Order Confirmation',
    scanQRCodePrompt: 'Please scan the QR code in your confirmation email',
    selectActionToStart: 'Select An Action To Start',
    selfServiceKiosk: 'Self Service Kiosk',
    ticketPrintingDisabledWarning: 'Please note: Tickets purchased at this kiosk will not be printed. They will be emailed to you. A smartphone is required to access your tickets. Thank you!',
    useCardPrompt: 'Use your virtual card in-app or your physical card'
  },
  languages: {
    actions: {
      select: 'Select Language'
    },
    en: 'English',
    es: 'Spanish'
  },
  membership: {
    actions: {
      activateMembership: 'Activate Membership',
      addMember: 'Add Member | Add Members',
      // i.e. basic-ify member
      basicMember: 'Basic Member',
      becomeMember: 'Become Member',
      cancelMembership: 'Cancel Membership',
      changePlan: 'Change Plan',
      findExistingMember: 'Find Existing Member',
      findMember: 'Find Member',
      fixPending: 'Fix Pending',
      fixPendingCharge: 'Fix Pending Membership Charge',
      leaveAndStartSeparatePlan: 'Leave this membership and start a separate plan',
      lookupMember: 'Look Up Member',
      makeNameOwner: 'Make {name} owner',
      manage: 'Manage Membership',
      manageMember: 'Manage Member | Manage Members',
      memberLogIn: 'Member Log In',
      modifyMember: 'Modify Member',
      modifyMembership: 'Modify Membership',
      removeMember: 'Remove Member',
      removeNameAndStartSeparatePlane: 'Remove {name} and start separate plan',
      renewTerm: 'Renew {term}',
      seeYourPointsActivity: 'See Your Points Activity',
      selectOwner: 'Select Owner',
      turnOnRenewal: 'Turn On Renewal'
    },
    addFriendPrompt: 'Add a friend to get started',
    alreadyAMemberPrompt: 'Already a Member',
    availableToUsePrompt: 'Available to use',
    becomeMemberTodayPrompt: 'Become a member today and watch unlimited movies for FREE!',
    cancelAutomaticMembershipRenewalPrompt: 'Are you sure you would like to cancel automatic membership renewal?',
    changeTypeTooltip: 'Click to change membership type',
    createAccountPrompt: 'Create account to Purchase Membership',
    deleteMemberTooltip: 'Click or swipe to delete this member',
    earnPoint: 'Earn {rewardsCurrencyName}',
    earnPointForEverySpentOnConcessions: 'Earn {count} {rewardsCurrencyName} for every {currencyName} spent on concessions',
    earnPointForEverySpentOnTickets: 'Earn {count} {rewardsCurrencyName} for every {currencyName} spent on tickets',
    earnPointForEveryTicketValue: 'Earn {count} {rewardsCurrencyName} for every {currencyName} of ticket value',
    earnPointForEveryVisit: 'Earn {count} {rewardsCurrencyName} for every visit',
    editMemberDetailsTooltip: 'Click to edit this member\'s details',
    enabledAutomaticMembershipRenewalPrompt: 'Are you sure you would like to enable automatic membership renewal?',
    enableRenewalPrompt: 'Enable Renewal',
    errors: {
      cannotModifyOnline: 'The selected Membership Type cannot be modified online, select a different membership type or contact the cinema',
      currentUserIsNotOwner: 'You are not the owner of this membership',
      invalidMembershipVoucher: 'Unable to apply voucher due to invalid membership',
      nameCannotBeOwnerWithReasons: '{name} cannot be membership owner. Needs to have {reasons}.',
      nameMembershipTypeNotAvailableForVoucher: '{name}\'s membership type "{type}" is not available for the applied voucher',
      selectedRenewalPeriodNotAvailableForVoucher: 'The selected renewal period is not available for the applied voucher',
      selectedTypeNotAvailableForRenewalPeriod: 'A selected membership type is not available for the selected renewal period',
      selectedUserIsNotOwner: 'The selected user is not the owner of this membership',
      typeNotAvailableForSelectedRenewalPeriod: 'User membership type "{type}" is not available for the selected renewal period',
      userHasPaidMembership: 'User already exists and is on a paid membership. You must modify their existing membership first and move them to a free plan.',
      voucherMembershipTypeNotAvailableForName: 'Voucher membership type "{type}" is not available for {name}'
    },
    expiredIn: 'Expired in {date}',
    expiringPrompt: 'Expiring',
    fixCheckoutErrorsTooltip: 'Please fix outstanding membership errors before checking out',
    getFreeTicketEveryTermPrompt: 'Get {count} FREE ticket every {term} | Get {count} FREE tickets every {term}',
    invalidRenewalPeriodTooltip: 'The renewal period is invalid for one or more members',
    joinTodayPrompt: 'Join Today',
    keepTrackYourMoviesPrompt: 'Keep track of all the movies you have seen! Get customized recommendations',
    linkAMemberPrompt: 'Link a member',
    memberCount: '{count} Member | {count} Members',
    memberDetails: 'Member Details',
    memberLimitCountTooltip: 'Up to {count} members can be included on a single membership',
    membership: 'Membership | Memberships',
    membershipAndBillingPrompt: 'Membership and Billing',
    membershipCard: 'Membership Card',
    memberSince: 'Member Since {time}',
    nameIsOnActivePlanTooltip: '{name} is on an active and paid plan. You must first remove them from their existing plan before starting their own plan.',
    nextBillingDate: 'Next billing date: {date}',
    nowActiveMessage: 'Your Membership Is Now Active',
    periodStrategyDialogHeading: 'Prorate or Replace Membership',
    periodStrategyDialogPrompt: 'Do you want to prorate your new membership fee or replace your current membership?',
    removeMemberPrompt: 'Are you sure you want to permanently remove this member?',
    removeOrDowngradeMemberPrompt: 'Do you want to remove or downgrade this member to a basic free membership?',
    renewingPrompt: 'Renewing',
    saveAmountHeading: 'Save {amount}',
    searchForMemberDialogHeading: 'Find Existing Member',
    subscriptionCanceled: 'Subscription Canceled',
    tier: 'Tier | Tiers',
    tiersPrompt: 'Earn new and better rewards while using your membership!',
    trackAndRateMovies: 'Track and Rate Movies',
    turnOnAutoRenewalPrompt: 'Turn On Auto Renewal',
    viewAndManageMembershipPrompt: 'View & manage membership',
    watchUnlimitedMoviesPrompt: 'Watch unlimited movies (tickets are non-transferable, for member only, not their guests)',
    youAreOnActivePlanTooltip: 'You are on an active and paid plan. Contact the cinema or membership owner to remove you from the existing plan before starting your own plan.',
    youNeedMorePoints: 'You need {count} more {currencyName}',
    yourMembershipWillExpireOn: 'Your membership will expire on {date}'
  },
  movie: {
    actions: {
      rate: 'Rate',
      rated: 'Rated',
      removeRating: 'Remove Rating of {rating} Stars',
      select: 'Select Movie',
      watchTrailer: 'watch trailer'
    },
    cast: 'Cast',
    comingSoon: 'Coming Soon',
    director: 'Director',
    editYourWatchlistAndFavoriteMovies: 'Edit your watchlist and favorite movies',
    movie: 'Movie | Movies',
    movieRatedValue: 'Rated {value}',
    movieRating: 'Rating',
    myMovies: 'My Movies',
    nowPlaying: 'Now Playing',
    onSale: 'On Sale',
    overview: 'Overview',
    poster: 'Poster | Posters',
    producer: 'Producer',
    releaseDate: 'Release Date',
    showtimes: 'Showtimes',
    signInToSaveAMovie: 'Sign in to save a movie',
    youHaveSeenThisMovie: 'You have seen this movie!'
  },
  nav: {
    actions: {
      exploreThing: 'Explore {thing}',
      goBack: 'Go Back',
      goToHome: 'Go to home',
      readLess: 'Read Less',
      readMore: 'Read More',
      showAll: 'Show All',
      view: 'View',
      zoomIn: 'Zoom In',
      zoomOut: 'Zoom Out'
    },
    moreInformation: 'More Information'
  },
  order: {
    actions: {
      appliedToOrder: 'Applied to Order',
      startRefund: 'Start Refund',
      swapOrCredit: 'Swap or Credit',
      manageAtSite: 'Manage Order At {siteName}'
    },
    addMoreItems: 'Add More Items',
    comment: 'Comment | Comments',
    completeDetails: 'Complete Details',
    noCurrentOrders: 'No current orders',
    noOrders: 'No orders',
    noPastOrders: 'No past orders',
    noUpcomingOrders: 'No upcoming orders',
    // Need to confirm this is the word we want, between "Orden" or "Pedido"
    order: 'Order | Orders',
    orderHistory: 'Order History',
    pastOrder: 'Past Order | Past Orders',
    qROrderingDisabled: 'QR code ordering is no longer available for this showing',
    receipt: 'Receipt | Receipts',
    resendEmail: 'Resend Email',
    takeReceiptToCounterPrompt: 'Please take your receipt to the counter for payment',
    viewCurrentAndPastPurchasesPrompt: 'View current and past purchases',
    viewOrders: 'View Order | View Orders',
    viewReceipt: 'View Receipt',
    yourOrderNumber: 'Your Order Number'
  },
  pages: {
    account: {
      accountDeleted: 'Account Deleted',
      accountInformation: 'Account Information',
      accountOf: '{name}\'s Account',
      accountOverview: 'Account Overview',
      accountQueriesPrompt: ' Email {siteEmail} with further account queries',
      contactUsPrompt: 'Contact Us',
      deleteAccountPrompt: 'Are you sure you wish to delete your account? This operation is permanent and cannot be undone.\n\nYou can update any of your personal information or memberships with Modify Membership without permanently deleting your account.',
      deleteAccountTitle: 'Confirm Permanent Account Deletion',
      earnRewardsPrompt: 'Earn {currencyName} for rewards!',
      editYourContactInformationPrompt: 'Edit your contact information',
      errors: {
        accountDeletedError: 'An error occurred during account deletion'
      },
      myAccount: 'My Account',
      nextBooking: 'Next Booking',
      personalDetailsPrompt: 'Personal Details',
      preferredLanguageDescription: 'Content and messages will be shown in this language whenever possible.',
      redeemPointsPrompt: 'Redeem your {currencyName} for rewards!'
    },
    exploreMovies: {
      favoritesDescription: 'Your favorite movies!',
      moviesCountPrompt: 'There are {count} more movies in this list!',
      noMoviesHere: 'No movies here',
      ratingDescription: 'Movies you have rated!',
      searchOptionsPrompt: 'Search by title or date or actor!',
      searchPrompt: 'Search to find what you are looking for',
      signUpForListsPrompt: 'Sign up to start creating lists',
      unconfirmedMoviesDisclaimer: 'These movies not yet confirmed, help us decide to bring it adding a movie to your watch list!',
      watchedDescription: 'All movies you have watched at this theater!',
      watchListDescription: 'A list of movies you would like to watch!'
    },
    kioskActionSelection: {
      chooseOptionHeading: 'Choose an Option to Get Started'
    },
    kioskCart: {
      cardVoucherScanPrompt: 'If You Have Any Gift Cards or Vouchers, Scan/Swipe Them Now.'
    },
    kioskLogin: {
      actions: {
        lookupByEmailAndPassword: 'Look Up By Email and Password'
      },
      scanCardPrompt: 'Scan your virtual card in app or scan your physical card.',
      scanSwipeCardHeading: 'Scan/Swipe Membership Card Now'
    },
    kioskPayment: {
      actions: {
        addName: 'Add Name',
        printerWorkedFine: 'The Printer Worked Fine'
      },
      enterNamePrompt: 'Please enter your first name'
    },
    kioskUserLoginAction: {
      actions: {
        hardwareManagement: 'Hardware Management',
        yourOrders: 'Your Orders'
      },
      welcomeName: 'Welcome, {name}',
      whatWouldYouLikeToDo: 'What would you like to do?'
    },
    manageFriends: {
      actions: {
        addedFriendByCard: 'Added friend by card',
        copiedInviteToClipboard: 'Copied invite to clipboard',
        copyLinkToClipboard: 'Copy Link To Clipboard',
        linkAccount: 'Link Account',
        sendEmail: 'Send Email',
        sentFriendRequest: 'Sent friend request'
      },
      addFriendsAndFamilyBanner: 'Invite your friends and family allow purchasing on their behalf. This allows you to make use of their membership benefits and sit together.',
      addFriendsAndFamilyHeading: 'Add Friends and Family',
      addFriendsPrompt: 'Add your friends now so you can share your membership tickets, book together, and never get split across different seats, all without sharing a membership!',
      addFriendsShortenPrompt: 'Add your friends to book together and more',
      addFriendsToPurchaseTicketsTogether: 'Add your friends and family to purchase tickets together!',
      cardInstructions: 'Enter the membership card number and last name of your friend or family member to establish a link with their account.',
      emailInviteInstructions: 'Your friend or family member will receive an email with a link to authorize connecting your accounts.',
      errors: {
        unableToCopyInviteToClipboard: 'Unable to copy invite to clipboard'
      },
      linkInstructions: 'Share this link with your friends and family. By clicking on the link, they can authorize you to purchase on their behalf.',
      posAddFriendsToPurchaseTicketsTogether: 'Add friends and family to purchase tickets together!',
      wouldYouLikeToPurchaseTicketsForOtherMembers: 'Would You Like to Purchase Tickets for Other Members?'
    },
    membership: {
      addToWatchListPrompt: 'Your watchlist is missing all the best upcoming movies!',
      buyTicketsPrompt: 'You need to buy tickets for your next great movie!',
      countDaysLeft: '{count} days left',
      countMoreMovie: '{count} more Movie | {count} more Movies',
      countMoreTicket: '{count} more Ticket | {count} more Tickets',
      countMoreVisit: '{count} more Visit | {count} more Visits',
      countMorePoint: '{count} more {rewardsCurrencyName} | {count} more {rewardsCurrencyName}',
      countMovie: '{count} Movie | {count} Movies',
      countVisit: '{count} Visit | {count} Visits',
      countPoint: '{count} {rewardsCurrencyName} | {count} {rewardsCurrencyName}',
      logInPrompt: 'Log In to See Your Membership',
      myMembership: 'My Membership',
      point: '{rewardsCurrencyName} | {rewardsCurrencyName}',
      pointBalance: '{rewardsCurrencyName} Balance | {rewardsCurrencyName} Balance',
      reward: 'Reward | Rewards',
      termInReview: '{term} in review',
      tierDaysUntilDowngrade: 'Days until your tier will downgrade (without new activity)',
      toAchieveNextTierStatus: 'To achieve {tier} status',
      toMaintainTierStatus: 'To maintain {tier} status',
      totalDays: 'Total Days',
      totalDaysDescription: 'How many days you\'ve spent in {name}',
      totalMovies: 'Total Movies',
      totalTickets: 'Total Tickets',
      totalVisits: 'Total Visits',
      visit: 'Visit | Visits'
    },
    modifyMembership: {
      heading: 'Membership Details'
    },
    moreFilms: {
      heading: 'Other films you may enjoy'
    },
    orderConfirmation: {
      takeTicketsReminder: 'Remember To Take Your Tickets',
      yourTicketsHaveBeenEmailed: 'Your tickets have been emailed to {email}',
      noEmailProvided: 'No email address provided'
    },
    payment: {
      actions: {
        managePaymentMethod: 'Manage Payment Method',
        payAtCounter: 'Pay At Counter',
        printAndPayAtCounter: 'Print and Pay at Counter'
      },
      changeDueHeading: 'Change Due',
      confirmNewPriceAndRetryPrompt: 'Please confirm the new price and try completing your order again.',
      connectingToCardReader: 'Connecting to Card Reader, Please Wait...',
      contactDetailsHeading: 'Contact Details',
      deliveryHeading: 'Delivery',
      errors: {
        canOnlyCancelPendingOrder: 'You can only cancel a pending order',
        cardPaymentsUnavailable: 'Card Payments Unavailable',
        invalidPromoCode: 'Invalid Promo Code',
        invalidPromoCodeOrCEACard: 'Invalid Promo Code or CEA Card',
        issueWithOrder: 'There was an issue completing your order',
        issueWithPayment: 'There was an issue with your payment',
        limitedRunDiscountNoLongerValid: 'Limited Run Discount No Longer Valid',
        priceForItemsHaveChanged: 'The price for the items you are purchasing have changed.',
        problemWithOrderTryAgain: 'There is a problem with your order, please start over and try again',
        unableToCommunicateWithChipReaderPayAtCounter: 'Unable to Communicate with Chip Reader, Please Pay at Counter'
      },
      foodAndDrinkHeading: 'Food & Drink',
      insertSwipeOrTapCardPrompt: 'Insert, Swipe or Tap Your Card Now',
      membershipRequiresRecurringPayments: 'The membership you are purchasing requires recurring payments.',
      pleaseTakeYourReceiptToCounter: 'Please take your receipt to the counter',
      pleaseWaitWhileWePlaceYourOrder: 'Please Wait while we place your order...',
      priceChangeHeading: 'Price Change',
      updateDetailsPrompt: 'Update Your Details'
    },
    paymentMethods: {
      heading: 'Manage Payment Cards',
      youHaveAPendingChargeOf: 'You have a pending charge of {amount}',
      yourAccountIsCurrent: 'Your account is current!'
    },
    redemptions: {
      redemptionRenewsCondition: '{name} up to {limit} redemptions {renews}',
      redemptions: 'Redemptions',
      rewardsAvailable: '{count} {currencyName} available to spend',
      rewardsIncludeHeading: '{currencyName} Rewards include:',
      seeRedemptions: 'See your available redemptions',
      toEarnRewardsCurrencyWithEveryPurchase: 'to earn {currencyName} with every purchase.',
      usingRewards: 'Using {count} of {currencyName}',
      noRedemptions: 'No redemptions found'
    },
    refundOrder: {
      heading: 'Refund Order',
      onlineRefundsAreToUserCredit: 'All online refunds are to user credit',
      repurchasingSameShowing: 'You can repurchase the same showing later, but only if there is still availability',
      swapShowingsInstructions: 'To swap showings, first refund, then purchase new tickets',
      ticketsWillBeReleased: 'Once you refund, your tickets will be released',
      youCanUseTheCreditNextTime: 'You can use the credit next time you checkout as a payment method'
    },
    selectTickets: {
      selectYourTicket: 'Select Your Ticket',
      additionalTickets: 'Additional Tickets',
      greeting: ctx => {
        const name = ctx.named('name')
        const membershipTypesAvailable = ctx.named('membershipTypesAvailable') || false
        return (name ? `Hi ${name},` : 'Hi There,') + ' Choose Your' + (membershipTypesAvailable ? ' Member' : '') + ' Tickets'
      },
      maximumTicketsPerOrderMessage: 'Maximum of {limit} tickets per order',
      noTicketsMessage: 'No Tickets Available'
    }
  },
  payment: {
    actions: {
      addWithChipReader: 'Add With Chip Reader',
      cashAmountDoesNotMatchSplit: 'Cash amount does not match split amount',
      payAmountWithMethod: 'Pay {amount} With {method}',
      payWithMethod: 'Pay with {method}',
      printReceipt: 'Print Receipt',
      processCashPayments: 'Process Cash Payments',
      reconnectToChipReader: 'Reconnect To Chip Reader',
      redeem: 'Redeem',
      redeemed: 'Redeemed',
      useGiftCardOfValue: 'Use {value} Gift Card',
      useValueOfCredit: 'Use {value} of Credit'
    },
    check: 'Check | Checks',
    configuringReader: 'Configuring reader...',
    errors: {
      chipReaderNotConnected: 'Chip reader not connected',
      noChipReaderSelected: 'No chip reader selected'
    },
    method: 'Payment Method | Payment Methods',
    payment: 'Payment | Payments',
    paymentInfoPrompt: 'Manage your saved credit & gift cards',
    paymentInformation: 'Payment Information',
    processing: 'Processing Payment...',
    required: 'Payment required',
    waitingForCustomerToProvidePayment: 'Waiting for customer to provide payment'
  },
  person: {
    dayPassHolder: 'Day Pass Holder',
    existingCustomer: 'Existing Customer',
    existingCustomerWithoutEmail: 'Existing Customer Without Email Address',
    friend: 'Friend | Friends',
    newCustomer: 'New Customer',
    you: 'You'
  },
  pricing: {
    additionalFeePerTicketApplied: 'An additional {amount} {feeName} is applied at checkout',
    additionalFeePerTicketAppliedPerTicket: 'An additional {amount} {feeName} per ticket is applied at checkout',
    balanceIsOfValue: 'Balance of {value}',
    change: 'Change',
    credit: 'Credit',
    creditUnit: 'Credit | Credits',
    discount: 'Discount | Discounts',
    donation: 'Donation | Donations',
    free: 'Free',
    pricing: 'Pricing',
    remaining: 'Remaining',
    savings: 'Savings',
    subtotal: 'Subtotal',
    surcharge: 'Surcharge',
    tax: 'Tax',
    taxable: 'Taxable',
    ticketPriceIncludesAmountOfFee: 'Ticket price includes {amount} {feeName}',
    tip: 'Tip | Tips',
    total: 'Total',
    totals: 'Totals',
    custom: 'Custom',
    startingAt: 'Starting at'
  },
  screen: {
    screen: 'Screen | Screens'
  },
  search: {
    actions: {
      clearFilters: 'Clear Filter | Clear Filters',
      filter: 'Filter',
      filterBy: 'Filter by',
      search: 'Search'
    },
    alphabetical: 'Alphabetical',
    for: {
      anything: 'Search anything...',
      member: 'Find Member',
      movieOrPage: 'Search for movie or page...',
      titleGenreActorDate: 'Title, genre, actor, date...',
      venue: 'Search for a venue',
      location: 'Search for a location'
    },
    noMatches: 'No matches',
    noResults: 'No results'
  },
  seatChart: {
    actions: {
      selectSeat: 'Select Seat | Select Seats',
      setHeldSeatCount: 'Set Held Seat Count',
      keepThem: 'Keep Them',
      removeThem: 'Remove Them'
    },
    errors: {
      mustNotExceedSeatCountTicketsSoldCount: 'Must not exceed the seat count - tickets sold ({count})'
    },
    legend: 'Seat Legend',
    newHeldSeatCount: 'New Held Seat Count',
    noSeatsSelected: 'No Seats Selected',
    priorSeats: 'Prior Seats',
    socialDistancing: 'Social Distancing',
    types: {
      couch: 'Couch',
      recliner: 'Recliner',
      table: 'Table',
      wheelchair: 'Wheelchair',
      companion: 'Companion'
    },
    pinchZoom: 'Pinch to zoom',
    scrollZoom: 'Scroll to zoom',
    selectSeatToContinue: 'Select a seat to continue',
    selectSeatsToContinue: 'Select {count} seats to continue',
    selectTicketToContinue: 'Select a ticket to continue',
    selectTicketsToContinue: 'Select {count} tickets to continue',
    capacityPercentFull: '{count}% full',
    newShowtimeSelected: 'New Showtime Selected',
    newShowtimeSelectedPrompt: 'You have tickets in your cart for another showtime',
    currentShowtime: 'Current Showtime',
    newShowtime: 'New Showtime'
  },
  showing: {
    actions: {
      viewNext: 'View Next Showing | View Next Showings'
    },
    noLongerAvailableForPurchaseOnline: 'No longer available for purchase online',
    noMoreTicketsAvailableForShowing: 'No more tickets available for showing',
    noShowingsToday: 'No showings for today',
    nothingScheduled: 'Nothing Scheduled',
    predictedAttendanceLevel: 'Predicted attendance level',
    removeSearchFiltersPrompt: 'Remove filters to display more showings',
    showing: 'Showing | Showings',
    showingsCalendar: 'Showings Calendar',
    showMeTimesFor: 'Show me times for {subject}',
    showtimesFor: 'Showtimes for {subject}',
    ticketsGoOnSale: 'Tickets go on sale {time}'
  },
  siteLocation: {
    actions: {
      add: 'Add Location',
      change: 'Change Location',
      select: 'Select Location',
      useCurrentLocation: 'Use current location'
    },
    all: 'All Locations',
    chooseCinemaPrompt: 'Please choose a cinema',
    closestLocation: 'Closest Location | Closest Locations',
    directions: 'Directions',
    location: 'Location | Locations',
    selectLocationHeading: 'Select a Location',
    selectLocationPrompt: 'Please Select A Location',
    selectLocationQuestion: 'Change location?',
    watchingMovieAtADifferentLocationQuestion: 'Watching at a different location?',
    whichCinemaQuestion: 'Where would you like to see the film?'
  },
  status: {
    active: 'Active',
    available: 'Available',
    expired: 'Expired',
    held: 'Held',
    loading: 'Loading',
    sold: 'Sold',
    soldOut: 'Sold Out',
    soldOutShort: 'Sold Out',
    status: 'Status',
    unavailable: 'Unavailable',
    used: 'Used',
    reserved: 'Reserved'
  },
  ticket: {
    actions: {
      addDayPass: 'Add Day Pass',
      book: 'Book Ticket | Book Tickets',
      buy: 'Buy Ticket | Buy Tickets',
      buyDayPass: 'Buy Day Pass',
      print: 'Print Ticket | Print Tickets'
    },
    activityTicket: 'Activity Ticket | Activity Tickets',
    collect: 'Collect Ticket | Collect Tickets',
    collected: 'Ticket Collected | Tickets Collected',
    dayPass: 'Day Pass',
    dayPassPurchase: 'Day Pass Purchase',
    errors: {
      dayPassNoLongerValid: 'Day Pass no longer valid'
    },
    groupTicket: 'Group Ticket | Group Tickets',
    memberTicket: 'Member Ticket | Member Tickets',
    ticket: 'Ticket | Tickets',
    ticketCount: '{count} Ticket | {count} Tickets',
    ticketsLeftCount: '{count} Ticket Left | {count} Tickets Left',
    ticketsRemaining: 'Tickets Remaining',
    ticketsRemainingCount: '{count} Ticket Remaining | {count} Tickets Remaining',
    ticketsSold: 'Tickets Sold',
    viewTicketOptions: 'View ticket options'
  },
  time: {
    actions: {
      selectDateAndTime: 'Select Date & Time'
    },
    annually: 'Annually',
    biannually: 'Biannually',
    birthday: 'Birthday',
    date: 'Date',
    endDate: 'End Date',
    endsToday: 'Ends Today',
    endsTomorrow: 'Ends Tomorrow',
    expiresAt: 'Expires {time}',
    leavesSoon: 'Leaves Soon',
    month: 'Month | Months',
    monthCount: '{count} Month | {count} Months',
    monthly: 'Monthly',
    onDate: 'On {date}',
    otherDateWithIcon: 'Other {icon} Date',
    quarterly: 'Quarterly',
    redeemedAtTime: 'Redeemed At {time}',
    startingSoon: 'Starting Soon',
    starts: 'Starts',
    startsOn: 'Starts {time}',
    today: 'Today',
    tomorrow: 'Tomorrow',
    year: 'Year | Years'
  },
  user: {
    account: 'Account | Accounts',
    actions: {
      addToFavorites: 'Add to Favorites',
      addToWatchList: 'Add to Watch List',
      deleteAccount: 'Delete Account',
      editDetails: 'Edit Details',
      find: 'Find User',
      manageFriends: 'Manage Friends',
      manageMarketingPreferences: 'Manage Marketing Preferences',
      removeFromFavorites: 'Remove from Favorites',
      removeFromWatchList: 'Remove from Watch List',
      retryPayment: 'Retry Payment',
      seeAllFavorites: 'See All Favorites',
      select: 'Select User'
    },
    allowPurchasesBy: 'Allow Purchases By',
    employeeDetails: 'Employee Details',
    emptyFriendsList: 'Your friends list is currently empty',
    manageContactMethod: 'Manage how we contact you',
    marketingPreferences: 'Marketing Preferences',
    pickedForYou: 'Picked for you',
    point: 'Point | Points',
    preferredLanguage: 'Preferred Language',
    userClass: 'User Class',
    watchList: 'Watch List'
  },
  voucher: {
    actions: {
      enterCode: 'Enter Voucher Code',
      use: 'Use Voucher'
    },
    copiedToClipboard: 'Code copied to clipboard',
    errors: {
      copyFailed: 'Copy failed',
      hasExpired: 'Voucher has expired',
      invalid: 'Invalid Voucher',
      notFound: 'Voucher not found',
      notValid: 'Voucher is not valid'
    },
    expiredAbbreviation: 'Exp',
    myVoucher: 'My Voucher | My Vouchers',
    noAvailableVouchersPrompt: 'You have no available vouchers',
    voucher: 'Voucher | Vouchers',
    voucherCount: '{count} Voucher | {count} Vouchers'
  },
  voucherPackage: {
    actions: {
      selectAllCountNotRedeemed: 'Select All ({count}) Not Redeemed'
    },
    errors: {
      invalidPackage: 'Invalid Voucher Package',
      notValid: 'Not Valid'
    },
    packageNameHeading: 'Voucher Package: {name}',
    purchase: 'Voucher Package Purchase',
    stateNotRedeemed: '{state}, Not Redeemed',
    voucherPackage: 'Voucher Package | Voucher Packages',
    voucherTypeHeading: 'Voucher Type: {type}'
  }
}
